import React from "react";

const Modal = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex z-30 items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg relative">{children}</div>
    </div>
  );
};

export default Modal;
